import API from 'utils/api';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/riesgo-de-trabajo/';

/**
 * GET Riesgo De Trabajo Generales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getRiesgosDeTrabajo = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Riesgo De Trabajo general
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getRiesgoDeTrabajo = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Riesgo De Trabajo General
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postRiesgoDeTrabajo = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Riesgo De Trabajo General
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchRiesgoDeTrabajo = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Riesgo De Trabajo General
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteRiesgoDeTrabajo = async (id) => {
  try {
    const response = await API.delete(`${baseURI} ${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
